var country_lookup = {
    'ukraine': 'ua',
    'russia': 'ru',
    'belarus': 'by',
    'moldova': 'md',
    'lithuania': 'lt',
    'latvia': 'lv',
    'estonia': 'ee',
    'kazakhstan': 'kz',
    'kyrgyzstan': 'kg',
    'uzbekistan': 'uz',
    'georgia': 'ge'
};
var componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
var formElements = {
    street_number: 'rstreetn',
    route: 'rstreet',
    locality: 'rcity',
    administrative_area_level_1: 'roblast',
    postal_code: 'rzip'
};
var autopomplete_callback;
export function initAutocomplete(callback, id) {
    autopomplete_callback = callback;
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    o_autocomplete = new google.maps.places.Autocomplete(document.getElementById(id ? id : 'g_autocomplete'), { types: ['geocode'] });
    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    o_autocomplete.addListener('place_changed', fillInAddress);
}
function fillInAddress() {
    var place = o_autocomplete.getPlace();
    if (!place.address_components)
        return;
    console.log(place);
    var elems = [];
    for (var i = 0; i < place.address_components.length; i++) {
        for (var j = 0; j < place.address_components[i].types.length; j++) {
            var addressType = place.address_components[i].types[j];
            if (componentForm[addressType]) {
                var vald = place.address_components[i][componentForm[addressType]];
                if (!$('#' + formElements[addressType]).attr('readonly'))
                    $('#' + formElements[addressType]).val(vald);
                if (formElements[addressType])
                    elems.push({ key: formElements[addressType], value: vald });
                break;
            }
        }
    }
    setTimeout(function () {
        let r = autopomplete_callback(null, null, elems);
        if (!r)
            $('#g_autocomplete').val('');
    });
}
export function restrictCountry(cname) {
    //    o_autocomplete.setComponentRestrictions({ 'country': cname.toLowerCase() });
    if (cname) {
        var clow = cname.toLowerCase();
        if (country_lookup[clow])
            o_autocomplete.setComponentRestrictions({ 'country': country_lookup[clow] });
        else
            o_autocomplete.setComponentRestrictions({ 'country': clow });
    }
}
///////////////////////////////////////////////////////////////////////////
var componentForm_s = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
};
var formElements_s = {
    street_number: 'sstreetn',
    route: 'sstreet',
    locality: 'scity',
    administrative_area_level_1: 'soblast',
    country: 'scountry',
    postal_code: 'szip'
};
var autopomplete_s_callback;
var o_autocomplete_s_handler;
export function initAutocomplete_s(callback, id) {
    autopomplete_s_callback = callback;
    // Create the autocomplete object, restricting the search to geographical location types.
    if (o_autocomplete_s_handler)
        o_autocomplete_s_handler.remove();
    o_autocomplete_s = new google.maps.places.Autocomplete(document.getElementById(id ? id : 'g_autocomplete_s'), { types: ['address'] });
    // When the user selects an address from the dropdown, populate the address fields in the form.
    o_autocomplete_s_handler = o_autocomplete_s.addListener('place_changed', fillInAddress_s);
}
export function buildSenderAddress() {
    var addrComp = [];
    for (var p in formElements_s) {
        var el = $('#' + formElements_s[p]).val();
        if (el && el != '')
            addrComp.push(el);
    }
    return addrComp.length > 0 ? addrComp.join(', ') : '';
}
export function getAddressComponent(addr, comp) {
    for (var i = 0; i < addr.length; i++) {
        for (var j = 0; j < addr[i].types.length; j++) {
            var addressType = addr[i].types[j];
            if (componentForm_s[addressType] && addressType == comp) {
                var vald = addr[i][componentForm_s[addressType]];
                if (comp == 'country') {
                    if (vald == 'United States')
                        vald = 'USA';
                    else if (vald == 'Canada')
                        vald = 'CAN';
                }
                return vald;
            }
        }
    }
    return '';
}
export function restrictCountry_s(cnames) {
    o_autocomplete_s.setComponentRestrictions({ 'country': cnames });
}
function fillInAddress_s() {
    var place = o_autocomplete_s.getPlace();
    if (!place.address_components)
        return;
    console.log(place);
    var stateprov = '';
    var country = '';
    var elems = [];
    for (var i = 0; i < place.address_components.length; i++) {
        for (var j = 0; j < place.address_components[i].types.length; j++) {
            var addressType = place.address_components[i].types[j];
            if (componentForm_s[addressType]) {
                var vald = place.address_components[i][componentForm_s[addressType]];
                if (formElements_s[addressType] == 'soblast')
                    stateprov = vald;
                else if (formElements_s[addressType] == 'scountry') {
                    if (vald == 'United States')
                        vald = 'USA';
                    country = vald;
                }
                else
                    elems.push({ key: formElements_s[addressType], value: vald });
                $('#' + formElements_s[addressType]).val(vald);
                break;
            }
        }
    }
    setTimeout(function () {
        autopomplete_s_callback(country, stateprov, null);
        let r = autopomplete_s_callback(null, null, elems);
        if (!r)
            $('#g_autocomplete_s').val('');
    });
}
//# sourceMappingURL=autocompleteAddress.js.map